import { Injectable, signal } from '@angular/core';
import { IWeather } from '../interfaces/IWeather';

@Injectable({
  providedIn: 'root'
})
export class DashboardStore {

  public readonly weather = signal<IWeather>(null);
}
